module.exports = __webpack_public_path__ + "static/img/missing-parcel-marker.d125657.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/missing-parcel-marker.png
// module id = 792
// module chunks = 3